import { __awaiter } from "tslib";
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { BaseButton, ModalX } from '../../../../../BaseComponents';
import { useToggleable } from '../../../../../hooks';
import { useTheme } from '../../../../../theme';
import { useCancelOrder } from '../../lib/useCancelOrder';
import { CdnIcon } from '@shared/ui';
const CancelOrderConfirm = ({ orderId }) => {
    const { t } = useTranslation('Checkout');
    const { CancelOrderConfirm: theme } = useTheme('Features').CancelOrder;
    const { isOpen, open, close } = useToggleable(false);
    const { onCancelOrder, cancelOrderResult } = useCancelOrder();
    const onCancelOrderHandler = () => __awaiter(void 0, void 0, void 0, function* () {
        yield onCancelOrder({ id: orderId });
        close();
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(BaseButton, { variant: "optionEdit", className: theme.cancelButton, onClick: open }, t('Cancel order')),
        React.createElement(ModalX, { isOpen: isOpen },
            React.createElement("div", { className: theme.content },
                React.createElement("div", { className: theme.title },
                    React.createElement("div", { className: theme.icon },
                        React.createElement(CdnIcon, { icon: "Info/Warning" })),
                    t('Are you sure you want to cancel the order?')),
                React.createElement("div", { className: theme.buttons },
                    React.createElement(BaseButton, { variant: "action", className: theme.button, onClick: onCancelOrderHandler, isLoading: cancelOrderResult.loading }, t('Cancel order')),
                    !cancelOrderResult.loading && (React.createElement(BaseButton, { variant: "secondary", className: theme.button, onClick: close }, t('Close'))))))));
};
export default CancelOrderConfirm;
